import {ApplicationRef, Component, HostListener, OnInit} from '@angular/core';
import {DomSanitizer, Title} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {SwUpdate, VersionReadyEvent} from '@angular/service-worker';
import {Store} from '@ngrx/store';
import {filter, take} from 'rxjs/operators';
import {alert} from 'devextreme/ui/dialog';
import * as Sentry from '@sentry/angular-ivy';

import {LogOut} from 'src/app/stores/actions/fusion-auth.actions';
import {AppState} from 'src/app/stores/app.state';
import {FusionAuthService} from './shared/services/fusion-auth';
import {AppInfoService} from './shared/services/general';
import {LabSettingsService} from './shared/services/ocl';
import {SentryBreadcrumbCategory} from "../enum/sentry-breadcrumb-category";
import themes from "devextreme/ui/themes";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {

  constructor(
    private titleService: Title,
    private store: Store<AppState>,
    private laboratorySettings: LabSettingsService,
    public applicationInfo: AppInfoService,
    private fusionAuth: FusionAuthService,
    private swUpdate: SwUpdate,
    private sanitizer: DomSanitizer,
  ) {
    themes.current(window.localStorage.getItem('dx-theme') || "generic.light.compact");
  }


  @HostListener('contextmenu', ['$event'])
  public onRightClick(event: Event) {
    event.preventDefault();
  }

  @HostListener('window:keydown', ['$event'])
  public onKeyDown(event: KeyboardEvent) {
    if ((event.metaKey || event.ctrlKey) && event.key === 's') {
      event.preventDefault();
      alert('This action is not allowed.', 'Error').then();
    }
  }

  private serviceWorkerInit() {
    if ('serviceWorker' in navigator) {
      this.swUpdate.versionUpdates.pipe(filter(x => x.type === 'VERSION_READY'))
      .subscribe(event => {
        Sentry.setContext(SentryBreadcrumbCategory.serviceWorkerUpdate, {
          currentVersion: (event as VersionReadyEvent).currentVersion.hash,
          versionAvailable: (event as VersionReadyEvent).latestVersion.hash
        });
      });
      this.swUpdate.versionUpdates.pipe(filter(x => x.type === 'VERSION_READY'))
      .subscribe(event => {
        Sentry.setContext(SentryBreadcrumbCategory.serviceWorkerUpdate, {
          currentVersion: (event as VersionReadyEvent).currentVersion.hash,
          versionAvailable: (event as VersionReadyEvent).latestVersion.hash
       });
      });

      setInterval(() => {
        try {
          if (this.swUpdate.isEnabled) {
            this.swUpdate.checkForUpdate()
              .then(() =>
                Sentry.addBreadcrumb({
                  category: SentryBreadcrumbCategory.serviceWorker,
                  message: 'Service worker updated the application.',
                  level: 'info',
                }))
              .catch(e => {
                Sentry.addBreadcrumb({
                  category: SentryBreadcrumbCategory.serviceWorker,
                  message: 'There was an error updating the application.',
                  level: 'error',
                });
                Sentry.captureException(e);
                location.reload();
              });
          }
        } catch (e) {
          Sentry.addBreadcrumb({
            category: SentryBreadcrumbCategory.serviceWorker,
            message: 'There was an error updating the application.',
            level: 'error',
          });
          Sentry.captureException(e);
          location.reload();
        }
      }, 5 * 60 * 1000);

      setInterval(() => {
        if (this.fusionAuth.hasBeenLogged() === 'true') {
          alert('Your session expired. You must login to continue.', 'Logged out').then(() => {
            this.fusionAuth.clearHasBeenLogged();
            this.store.dispatch(new LogOut());
          });
        }
      }, 15000);

      this.swUpdate.versionUpdates
        .pipe(filter((x) => x.type === 'VERSION_READY'))
        .subscribe(() => {
          alert(
            'A new version was downloaded, this window will refresh in a few seconds.',
            'New Web Portal'
          ).then();
          setTimeout(
            () => this.swUpdate.activateUpdate().then(() => location.reload()),
            15000
          );
        });
    }
  }

  public ngOnInit(): void {
    this.serviceWorkerInit();

    this.laboratorySettings.getSettings()
      .pipe(take(1))
      .subscribe(settings => {
        this.applicationInfo.logo = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image;base64,${settings.logo}`) as string;
        this.applicationInfo.lab = settings.name;
        this.applicationInfo.title = `${settings.name} - LIS Portal`;
        this.applicationInfo.labAddress = settings.address;
        this.applicationInfo.email = settings.email;
        this.applicationInfo.labPhone = settings.phone;
        this.titleService.setTitle(this.applicationInfo.title);
      });
  }

  @HostListener('document:mousemove')
  public onMouseMove() {
    localStorage.setItem('idleTime', '0');
  }

  @HostListener('document:keypress')
  public onKeyPress() {
    localStorage.setItem('idleTime', '0');
  }
}
